module.exports = __webpack_public_path__ + "img/xx.865641b0.png";